import { useState } from "react";
import { RoomCard } from "./RoomCard";
import { RoomDrawer } from "./RoomDrawer";
import { useRooms } from "@/hooks/useRooms";
import { usePatientsByRoom } from "@/hooks/usePatients";
import { Skeleton } from "@/components/ui/skeleton";

export const RoomList = () => {
  const [expandedRoomIndex, setExpandedRoomIndex] = useState<number | null>(0);
  const { data: rooms, isLoading, error } = useRooms();

  const toggleRoom = (index: number) => {
    setExpandedRoomIndex(expandedRoomIndex === index ? null : index);
  };

  if (isLoading) {
    return (
      <div className="w-full px-2 sm:px-3 py-2 sm:py-3 space-y-2 sm:space-y-3">
        {Array.from({ length: 4 }).map((_, i) => (
          <div key={i} className="bg-card border border-border rounded-lg p-3 space-y-2">
            <div className="flex items-center justify-between">
              <Skeleton className="h-5 w-32" />
              <Skeleton className="h-5 w-20" />
            </div>
            <div className="flex gap-3">
              <Skeleton className="h-4 w-24" />
              <Skeleton className="h-4 w-24" />
            </div>
          </div>
        ))}
      </div>
    );
  }

  if (error) {
    return (
      <div className="w-full px-2 py-1.5">
        <div className="text-center text-destructive">Error loading rooms</div>
      </div>
    );
  }

  if (!rooms || rooms.length === 0) {
    return (
      <div className="w-full px-2 py-1.5">
        <div className="text-center text-muted-foreground">No rooms available</div>
      </div>
    );
  }

  return (
    <div className="w-full px-2 sm:px-3 py-2 sm:py-3">
      <div className="space-y-2 sm:space-y-3">
        {rooms.map((room, index) => (
          <RoomListItem
            key={room.id}
            room={room}
            index={index}
            isExpanded={expandedRoomIndex === index}
            onToggle={() => toggleRoom(index)}
          />
        ))}
      </div>
    </div>
  );
};

const RoomListItem = ({ room, index, isExpanded, onToggle }: any) => {
  const { data: patients } = usePatientsByRoom(room.room_name);

  return (
    <div>
      <RoomCard
        roomName={room.room_name}
        patientCount={room.patient_count}
        avgTAT={room.avg_tat || "N/A"}
        isExpanded={isExpanded}
        onToggle={onToggle}
      />
      {isExpanded && (
        <RoomDrawer
          roomName={room.room_name}
          patientCount={room.patient_count}
          avgTAT={room.avg_tat || "N/A"}
          patients={patients || []}
        />
      )}
    </div>
  );
};
